import publicBuill from '../../../../components/reimbursement/js/publicBuill'
export default {
  name: 'oaDzjmfksqd',
  data() {
    return {
      sqbm: '',
      rq: '',
      djh: '',
      gys: '',
      gyslb: '',
      gysbm: '',
      hrdwmc: '',
      hrdwzh: '',
      hrdwkhh: '',
      je: '',
      jedx: '',
      hkyt: '',
      bz: '',
      flowId: '',
      lrr: '',
      lrrid: '',
      optionscwjzdw: [{
        label: '供应商',
        options: []
      }, {
        label: '客户',
        options: []
      }],
      reviewer: ['', '', '', '', '', ''],
      config: {
        fixed: true,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        loadingcwjzdw: false,
        searchTables: false,
        height: '16vh',
        indexWidth: '100%'
      },
      user: {},
      grjk: {
        ljjk: '0.00',
        yhk: '0.00',
        jkje: '0.00'
      },
      activeName: 'second'
    }
  },
  mounted() {
    this.user = localStorage
    this.rq = publicBuill.dateToString(new Date()) /* 时间初始化 */
  },
  created() {
    publicBuill.setThis(this)
  },
  methods: {
    /* 财务记账单位 */
    remoteMethod(query) {
      publicBuill.remoteMethodZD(query)
    },
    changecwjzdw(event) {
      publicBuill.changecwjzdw(event)
      publicBuill.getZDFKsqdZhAndKhhByGys({ dictName: this.gys, dictCode: 'ZM' }).then(res => {
      })
    },
    jeChange() {
      this.jedx = publicBuill.convertCurrency(this.je)
    },
    submitForm() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        djh: this.djh,
        gyslb: this.gyslb,
        gys: this.gys,
        gysbm: this.gysbm,
        bmbm: localStorage.getItem('deptNo'),
        bmmc: localStorage.getItem('groupName'),
        hkyt: this.hkyt,
        hrdwmc: this.hrdwmc,
        hrdwzh: this.hrdwzh,
        hrdwkhh: this.hrdwkhh,
        je: this.je,
        bz: this.bz,
        lrr: localStorage.getItem('userName'),
        lrrId: localStorage.getItem('userNo'),
        flowId: this.flowId,
        rejected: '0'
      }
      if (this.gys === '') {
        this.$message('汇入单位名称不能为空')
        this.config.loading = false
        loading.close()
      } else if (this.jexx === '') {
        this.$message('金额不能为空')
        this.config.loading = false
        loading.close()
      }
      this.$post('/fesback/fksqdJmDz/save.z', data).then(response => {
        if (response.success === true) {
          this.resetForm()
          this.$message.success(response.message)
        } else {
          this.$message.error(response.message)
        }
        loading.close()
      })
    },
    resetForm() {
      const data = this.$data
      Object.keys(data).forEach(key => {
        if (typeof data[key] === 'string' && !(key === 'activeName' || key === 'valuebizhong' || key === 'rq')) {
          data[key] = ''
        }
      })
    }
  }
}
